import { action, makeObservable, observable, runInAction } from "mobx";
import SwayyWaitlistAPI from "../api/SwayyWaitlistAPI";
import { APIBlobResponse, PaginatedAPIResponse } from "../models/NetworkResponse";
import { WaitlistEntry } from "../models/Swayy/Waitlist";
import { WaitlistFilters } from "../models/Swayy/WaitlistFilters";

export class SwayyWaitlistStore {
  waitlistAPI: SwayyWaitlistAPI;
  waitlist: WaitlistEntry[] = [];
  limit = 0;
  total_count = 0;
  total_pages = 0;

  constructor() {
    this.waitlistAPI = new SwayyWaitlistAPI();
    makeObservable(this, {
      waitlist: observable,
      limit: observable,
      total_count: observable,
      total_pages: observable,
      getWaitlist: action,
    });
  }

  getWaitlist = async (filters: WaitlistFilters) => {
    const response = (await this.waitlistAPI.getWaitlist(
      filters,
    )) as PaginatedAPIResponse<WaitlistEntry>;
    runInAction(() => {
      this.limit = response.limit;
      this.total_count = response.total_count;
      this.total_pages = response.total_pages;
      this.waitlist = response.list;
    });
  };

  downloadWaitlist = async (): Promise<APIBlobResponse> => {
    return this.waitlistAPI.downloadWaitlist();
  };
}
